import styled from 'styled-components';
import { Row, Col } from '@pickit/pickit-grid-system';

export const LoadBarContainer = styled.div`
  border-radius: 4px;
  font-size: 12px;
  position: relative;
`;

export const ProgressBarContainer = styled(Row)`
  margin: 0 !important;
  position: absolute;
  top: 0;
`;

export const ProgressBar = styled(Col)<{ progress: number }>`
  align-items: center;
  background-color: ${({ theme, progress }) =>
    progress !== 0 ? theme.loadBar.progress : theme.loadBar.uncompleted};
  border-radius: 4px;
  color: white;
  display: flex;
  height: 21px;
  justify-content: end;
  padding-right: 6px;
`;

export const UncompletedBarContainer = styled(Row)`
  align-items: center;
  background-color: ${({ theme }) => theme.loadBar.uncompleted};
  border-radius: 4px;
  height: 21px;
  margin: 0 !important;
  padding-right: 6px;
  text-align: end;
`;

export const UncompletedBar = styled(Col)`
  display: flex;
  justify-content: flex-end;
  & > {
    width: 'fit-content';
  }
`;

export const TotalAmountContainer = styled.div<{ showTotalAmount: boolean }>`
  visibility: ${({ showTotalAmount }) => (showTotalAmount ? 'visible' : 'hidden')};
`;
